import { atom, getDefaultStore } from 'jotai'

import { getCurrentToken } from '@/utils/auth'

export const tokenAtom = atom<string | undefined>(getCurrentToken())

/**
 * Set once logout has handed the page to Auth0. Its redirect is a cross-origin navigation that can
 * take seconds, and everything the router does in the meantime is thrown away — including a lazy
 * chunk fetch that the unload aborts and the error boundary then renders as a failed page load.
 */
export const isLoggingOutAtom = atom<boolean>(false)

export const removeTokenAtom = () => {
  const store = getDefaultStore()
  store.set(tokenAtom, undefined)
}
